import { render, staticRenderFns } from "./DetailBookPage.vue?vue&type=template&id=df1bedf6&scoped=true"
import script from "./DetailBookPage.vue?vue&type=script&lang=js"
export * from "./DetailBookPage.vue?vue&type=script&lang=js"
import style0 from "./DetailBookPage.vue?vue&type=style&index=0&id=df1bedf6&prod&scoped=true&lang=css"
import style1 from "./DetailBookPage.vue?vue&type=style&index=1&id=df1bedf6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df1bedf6",
  null
  
)

export default component.exports